<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    databaseName?: string
    calculationNames?: string[]
    title?: string
    description?: string
  }>(),
  {
    databaseName: '',
    calculationNames: () => [],
    title: 'Environmental database in use',
    description:
      'This environmental database cannot be deleted because it is still selected or used by one or more calculations.\n\nIf you want to remove this database, delete the calculation that still uses it first.'
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const closeDialog = () => {
  emit('update:modelValue', false)
}
</script>

<template>
  <v-dialog
    :model-value="props.modelValue"
    max-width="640"
    persistent
    @update:model-value="(value) => !value && closeDialog()"
  >
    <v-card class="pa-3">
      <v-card-title>{{ props.title }}</v-card-title>
      <v-card-text class="pt-3 pl-4">
        <div
          v-for="(paragraph, index) in props.description.split('\n\n')"
          :key="index"
          :class="index > 0 ? 'mt-3' : ''"
        >
          {{ paragraph }}
        </div>
        <div v-if="props.databaseName" class="mt-3 font-weight-bold">{{ props.databaseName }}</div>

        <div v-if="props.calculationNames.length" class="mt-4">
          <div class="font-weight-medium">Used by calculations:</div>
          <div class="mt-2 d-flex flex-column ga-1">
            <div v-for="name in props.calculationNames" :key="name">- {{ name }}</div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer />
        <v-btn variant="text" color="primary" class="text-none" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
